import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import CompanyBusinessTags from '@/types/table/companyBusinessTags';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface CompanyBusinessTagsData extends CompanyBusinessTags {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class CompanyBusinessTagsController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<CompanyBusinessTagsData>>(API_CONTEXT + '/app/companyBusinessTags/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<CompanyBusinessTagsData>(API_CONTEXT + '/app/companyBusinessTags/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/companyBusinessTags/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/companyBusinessTags/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/companyBusinessTags/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/companyBusinessTags/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/companyBusinessTags/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/companyBusinessTags/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/companyBusinessTags/deleteBatch', params, httpOptions);
  }
}
